import { render, staticRenderFns } from "./TreeProductDomains.vue?vue&type=template&id=54c61f86&"
import script from "./TreeProductDomains.vue?vue&type=script&lang=js&"
export * from "./TreeProductDomains.vue?vue&type=script&lang=js&"
import style0 from "./TreeProductDomains.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports